import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { Touch } from "vuetify/lib/directives";
// import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify, {
  directives: {
    Touch
  }
})

export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#ff5f14",
        secondary: "#ff5f14",
        accent: "#edebea",
        error: "#FF5252",
        info: "#1c1920",
        success: "#4CAF50",
        warning: "#FFC107"
      },
      dark: {
        primary: "#e55512",
        secondary: "#e55512",
        accent: "#1c1920",
        error: "#FF5252",
        info: "#1c1920",
        success: "#4CAF50",
        warning: "#FFC107"
      }
    }
  },
  icons: {
    iconfont: "mdi"
  }
});
